module.exports = __webpack_public_path__ + "52915f25310e017942570da42c4e47a8.svg";